import {NgModule}                         from '@angular/core';
import {ApCroptypesOverviewComponent}     from './components/ap-croptypes.component';
import {ApVarietiesOverviewComponent}     from './components/ap-varieties.component';
import {
  BodyModule,
  FilterMenuModule,
  GridModule,
  HeaderModule,
  PagerModule,
  RowFilterModule
}                                         from '@progress/kendo-angular-grid';
import {CommonModule}                     from '@angular/common';
import {ApTranslationModule}              from '../translation/ap-translation.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  ButtonModule,
  DropDownButtonModule,
  SplitButtonModule
}                                         from '@progress/kendo-angular-buttons';
import {
  ComboBoxModule,
  DropDownsModule
}                                         from '@progress/kendo-angular-dropdowns';
import {ApUsersComponent}                 from './components/users/user/ap-users.component';
import {ApFertilizersOverviewComponent} from './components/ap-fertilizers.component';
import {ApPlantProtectionProductsComponent}    from './components/ap-plant-protection-products.component';
import {ApCoreModule}                   from '../ap-core/ap-core.module';
import {ApMachinesComponent}              from './components/machines/ap-machines.component';
import {ApInstrumentsComponent}           from './components/instruments/ap-instruments.component';
import {ApDriversComponent}               from './components/drivers/ap-drivers.component';
import {ApWorktypesOverviewComponent}     from './components/ap-worktypes.component';
import {ApSubFarmsComponent}              from './components/ap-subfarms.component';
import {ApDocuRessourcesComponent}        from './components/ap-docu-ressources.component';
import {ApDynformsModule}                 from '../ap-dynforms/ap-dynforms.module';
import {ApBasedataRoutes}                 from './ap-basedata.routes';
import {LayoutModule}                     from '@progress/kendo-angular-layout';
import {ApFertilizerCategoryMappingPipe}  from './pipes/ap-fertilizer-categorymapping.pipe';
import {ApUtilsModule}                    from '../ap-utils';
import {ApFertilizerInorgsComponent}      from './components/ap-fertilizer-inorgs.component';
import {ApFertilizerOrgsComponent}        from './components/ap-fertilizer-orgs.component';
import {DateInputsModule}                 from '@progress/kendo-angular-dateinputs';
import {ApUsersInvitationComponent}       from './components/users/invitation/ap-users-invitation.component';
import {ApUsersOverviewComponent}         from './components/users/ap-users-overview.component';
import {ApUsersAssignmentFarmComponent}   from './components/users/assignment/ap-users-assignment-farm.component';
import {ApUsergroupMappingPipe}           from './pipes/ap-usergroup-mapping.pipe';
import {ApResponsiveTextModule}           from '../ap-responsive-text/ap-responsive-text.module';
import {ApTooltipModule}                  from '../ap-tooltip/ap-tooltip.module';
import {ApSectionHeaderModule}            from '../ap-section-header/ap-section-header.module';
import {ApDynComponentModule}             from '../ap-dyncomponent/ap-dyncomponent.module';
import {GetMachineKindNamePipe}           from './pipes/machines/get-machine-kind-name.pipe';
import {ApPermissionModule}               from '../ap-permission/ap-permission.module';
import {ApTerminalsOverviewComponent}     from './components/terminals/ap-terminals.overview.component';
import {ApUserContactsOverviewComponent}  from './components/users/user-contacts/ap-user-contacts-overview.component';

@NgModule({
  declarations: [
    ApCroptypesOverviewComponent,
    ApVarietiesOverviewComponent,
    ApUsersComponent,
    ApFertilizersOverviewComponent,
    ApPlantProtectionProductsComponent,
    ApMachinesComponent,
    ApInstrumentsComponent,
    ApDriversComponent,
    ApWorktypesOverviewComponent,
    ApSubFarmsComponent,
    ApDocuRessourcesComponent,
    ApFertilizerCategoryMappingPipe,
    ApFertilizerInorgsComponent,
    ApFertilizerOrgsComponent,
    ApFertilizersOverviewComponent,
    ApUsersAssignmentFarmComponent,
    ApUsersOverviewComponent,
    ApUsersInvitationComponent,
    ApUsersComponent,
    ApUsergroupMappingPipe,
    GetMachineKindNamePipe,
    ApTerminalsOverviewComponent,
    ApUserContactsOverviewComponent
  ],
  imports: [
    ReactiveFormsModule,
    SplitButtonModule,
    ComboBoxModule,
    DateInputsModule,
    GridModule,
    ApCoreModule,
    ApTranslationModule,
    CommonModule,
    ApTranslationModule,
    ButtonModule,
    FormsModule,
    DropDownsModule,
    DropDownButtonModule,
    ApDynformsModule,
    LayoutModule,
    ApBasedataRoutes,
    ApUtilsModule,
    RowFilterModule,
    BodyModule,
    FilterMenuModule,
    HeaderModule,
    PagerModule,
    ApResponsiveTextModule,
    ApTooltipModule,
    ApSectionHeaderModule,
    ApDynComponentModule,
    ApPermissionModule
  ],
  exports: [
    ApCroptypesOverviewComponent,
    ApVarietiesOverviewComponent,
    ApUsersComponent,
    ApFertilizersOverviewComponent,
    ApPlantProtectionProductsComponent,
    ApMachinesComponent,
    ApInstrumentsComponent,
    ApDriversComponent,
    ApWorktypesOverviewComponent,
    ApSubFarmsComponent,
    ApDocuRessourcesComponent,
    ApFertilizerInorgsComponent,
    ApFertilizerOrgsComponent,
    ApFertilizersOverviewComponent,
    ApUsersOverviewComponent,
    ApUsersAssignmentFarmComponent,
    ApUsersInvitationComponent,
    ApUsersComponent,
    ApUsergroupMappingPipe,
    ApTerminalsOverviewComponent,
    ApUserContactsOverviewComponent
  ],
  providers: [
    GetMachineKindNamePipe,
  ]
})
export class ApBaseDataModule {
}
